export default "__VITE_PUBLIC_ASSET__5a529617__"